import React, { useState, useEffect } from 'react';
import { Button, Container, Modal, Row, Col, Form, Card } from 'react-bootstrap';
import API from '../../api';
import '../../css/charge_demo.css'
import ChargeCalculatorPartDemoApp from './ChargeCalculatorPartDemoApp';
import ChargeDemoPartApp from './ChargeDemoPartApp'
import logoImg from "../../images/demo/logo.png"

// import { useMappedState, useDispatch } from 'redux-react-hook';

export default function ChargeDemoApp(props) {
    const [calResult, setCalResult] = useState(null);

    useEffect(() => {
        // console.log("updated", isFetched);
        // if (false == isFetched) {
        API.init({ props });
        // Tools.init();
        // getData();
        // }
        // setIsFetched(true);
    });

    function onSubmit(data) {
        API.PaymentEstimate(data).
            then((data) => {
                if (data) {
                    if (null != data.price && null != data.platform_point) {
                        setCalResult(data);
                    } else if (data.msg) {
                        alert(data.msg);
                    }
                    else console.log(data);
                } else {
                    alert("Server error");
                    console.log(data);
                }
            });
    }

    function onSaveAndBack(data) {
        API.PaymentEstimate(data).
            then((data) => {
                if (data) {
                    if (null != data.price && null != data.platform_point) {
                        props.history.push("/projs/index");
                    } else if (data.msg) {
                        alert(data.msg);
                    }
                    else console.log(data);
                } else {
                    alert("Server error");
                    console.log(data);
                }
            });
    }

    function onDeposit() {
        props.history.push("/charge/index");
    }

    function render() {
        return (
            <Container className="pb-4">
                <h2 className='text-center mt-5 pb-5 bold_noto' style={{ color: "#1d2c94" }}>
                    <img src={logoImg} style={{ maxHeight: "100px", paddingRight: "13px", marginTop: "-9px", color: "#1d2c94", }} />智慧雲端調查平台
                </h2>
                <Row className="justify-content-md-center mb-5">
                    <Col xs={12} lg={12} xl={8}>
                        <ChargeCalculatorPartDemoApp onDeposit={onDeposit} isShowQCunts={true}
                            isEstimate={true} onSubmit={onSubmit} result={calResult}
                            onSaveAndBack={onSaveAndBack} />
                        <div className='mt-5'></div>
                        <ChargeDemoPartApp />
                    </Col>
                </Row>
            </Container >
        );
    }
    return render();
}